export default __webpack_public_path__ + "static/office-konst-1b77913d4adb82bcd8af8d42c2725b4a.png";